import PaymentMethodsTable from './PaymentMethodsTable';

export default PaymentMethodsTable;
